// extracted by mini-css-extract-plugin
export default {"wrapper":"CodeEditor_wrapper__Py0Oz"};